export class AddCompany {
    constructor(companyRepository) {
      this.companyRepository = companyRepository;
    }
  
    async execute(company) {
      return await this.companyRepository.addCompany(company);
    }
  }